<template>
  <vs-alert
    :value="true"
    color="warning"
    style="border:none;"
    :style="rounded?'border-radius: 15px':''"
    class="mb-5">
    <h3 class="starling-darkgrey--text">
      {{ $t('common.maintenance.notify.title') }}
    </h3>
    <p class="starling-darkgrey--text" :key="key">
      <span v-html="$t('common.maintenance.notify.message', {countdown, duration })"></span>
    </p>
  </vs-alert>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'maintenanceBar',
  props: {
    rounded: Boolean
  },
  data () {
    return {
      now: this.$moment(),
      key: 0,
      interval: null
    };
  },
  computed: {
    maintenance () {
      return this.$store.getters['maintenance/get'];
    },
    countdown () {
      if (!this.maintenance) return '';
      return Vue.filter('durationFormat')(this.$moment(this.maintenance.start).diff(this.now));
    },
    duration () {
      if (!this.maintenance) return '';
      return Vue.filter('durationFormat')(this.$moment.duration(this.maintenance.duration));
    }
  },
  watch: {
    maintenance () {
      this.now = this.$moment();
      this.$forceUpdate();
      this.key++;
    }
  },
  created () {
    this.interval = setInterval(() => {
      this.now = this.$moment();
      this.$forceUpdate();
      this.key++;
      if (this.maintenance && this.now.isSame(this.$moment(this.maintenance.start), 'second')) {
        this.$store.dispatch('maintenance/ping');
      }
    }, 1000);
  },
  destroyed () {
    clearInterval(this.interval);
  }
};
</script>

<style>
.v-snack.maintenance-snackbar .v-snack__wrapper {
  max-width: 80%;
}
</style>
